import { render, staticRenderFns } from "./WorkStageChip.vue?vue&type=template&id=85bc21b8"
import script from "./WorkStageChip.vue?vue&type=script&lang=js"
export * from "./WorkStageChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports